import Vue from 'vue'
import { format, parseISO } from 'date-fns'

Vue.filter('formatDateHour', (value, filterFormat) => {
  if (value) {
    if (value instanceof Date) {
      return format(value, filterFormat || 'HH')
    } else {
      return format(parseISO(value), filterFormat || 'HH')
    }
  }

  return ''
})
